import { apiSlice } from "services/apiSlice";

export const companyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanies: builder.query({
      query: () => "company",
      providesTags: ["Company"],
    }),

    getCompaniesByClient: builder.query({
      query: ({ clientId, companyId }) => ({
        url: `company/${companyId}/client/${clientId}`,
        method: "GET",
      }),
      providesTags: ["Company"],
    }),

    // ✅ Ajout de la mutation pour la mise à jour d'une entreprise
    updateCompanyInfo: builder.mutation({
      query: ({ companyId, data }) => ({
        url: `company/${companyId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCompaniesQuery,
  useGetCompaniesByClientQuery,
  useUpdateCompanyInfoMutation, // ✅ export de la mutation
} = companyApi;
